// extracted by mini-css-extract-plugin
export var actionText = "_lv-4";
export var container = "_lv-0";
export var leftSection = "_lv-1";
export var rightSection = "_lv-2";
export var settingsButton = "_lv-6";
export var settingsIcon = "_lv-7";
export var shortcut = "_lv-5";
export var shortcutGroup = "_lv-3";